import React from "react";
import PropTypes from 'prop-types';

export default class Row extends React.PureComponent {
    render() {
        let { children, className } = this.props;

        className = className ? ` ${className}` : '';

        return (
            <div className={`form-row ${className}`}>
                {children}
            </div>
        )
    }
}

Row.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
